//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TimelineChart',
  props: {
    view: {
      type: Boolean,
      default: false
    },
    initialProyectos: {
      type: Array,
      default: function _default() {
        return [{
          id: 1,
          name: 'Proyecto 001'
        }, {
          id: 2,
          name: 'Proyecto 002'
        }, {
          id: 3,
          name: 'Proyecto 003'
        }];
      }
    },
    initialUsuarios: {
      type: Array,
      default: function _default() {
        return [{
          id: 1,
          name: 'Usuario 001'
        }, {
          id: 2,
          name: 'Usuario 002'
        }, {
          id: 3,
          name: 'Usuario 003'
        }];
      }
    }
  },
  data: function data() {
    return {
      menu: true,
      // Controla la visibilidad del menú
      dateRange: [],
      // Almacena las fechas seleccionadas
      formattedDate: '',
      // Texto a mostrar en el campo de entrada

      selectedProyectos: [],
      proyectos: this.initialProyectos,
      selectedUsuarios: [],
      usuarios: this.initialUsuarios
    };
  },
  mounted: function mounted() {
    // Cargar la API de Google Charts
    this.loadGoogleCharts();
  },
  methods: {
    updateFormattedDate: function updateFormattedDate() {
      // Verifica si ambas fechas están seleccionadas
      if (this.dateRange[0] && this.dateRange[1]) {
        // Comprueba y corrige el orden de las fechas
        var startDate = new Date(this.dateRange[0]);
        var endDate = new Date(this.dateRange[1]);
        if (startDate > endDate) {
          // Intercambia las fechas si la inicial es mayor que la final
          var _ref = [this.dateRange[1], this.dateRange[0]];
          this.dateRange[0] = _ref[0];
          this.dateRange[1] = _ref[1];
        }

        // Formatea la fecha seleccionada para mostrarla en el campo de entrada
        this.formattedDate = "".concat(this.dateRange[0], " - ").concat(this.dateRange[1]);
        this.menu = false; // Cierra el menú una vez seleccionadas ambas fechas correctamente
      }
    },
    loadGoogleCharts: function loadGoogleCharts() {
      var script = document.createElement('script');
      script.src = 'https://www.gstatic.com/charts/loader.js';
      script.onload = this.drawChart; // Dibujar el gráfico al cargar la librería
      document.head.appendChild(script);
    },
    drawChart: function drawChart() {
      var _this = this;
      window.google.charts.load('current', {
        packages: ['corechart']
      });
      window.google.charts.setOnLoadCallback(function () {
        var container = _this.$refs.lineChart;
        var chart = new window.google.visualization.LineChart(container);

        // Crear la tabla de datos
        var data = new window.google.visualization.DataTable();
        data.addColumn('date', 'Fecha');
        data.addColumn('number', 'Opened');
        data.addColumn('number', 'Closed');

        // Datos de ejemplo (conversaciones por día)
        data.addRows([[new Date(2024, 9, 1), 5, 3],
        // 1 de octubre
        [new Date(2024, 9, 2), 8, 7],
        // 2 de octubre
        [new Date(2024, 9, 3), 12, 9],
        // 3 de octubre
        [new Date(2024, 9, 4), 15, 10],
        // 4 de octubre
        [new Date(2024, 9, 5), 10, 5],
        // 5 de octubre
        [new Date(2024, 9, 6), 20, 15],
        // 6 de octubre // 1 de octubre
        [new Date(2024, 9, 7), 5, 3],
        // 7 de octubre // 1 de octubre
        [new Date(2024, 9, 8), 8, 7],
        // 8 de octubre
        [new Date(2024, 9, 9), 12, 9],
        // 9 de octubre
        [new Date(2024, 9, 10), 15, 10],
        // 10 de octubre
        [new Date(2024, 9, 11), 10, 5],
        // 11 de octubre
        [new Date(2024, 9, 12), 20, 15],
        // 12 de octubre
        [new Date(2024, 9, 13), 15, 10],
        // 13 de octubre
        [new Date(2024, 9, 14), 10, 5],
        // 14 de octubre
        [new Date(2024, 9, 15), 20, 15] // 15 de octubre
        ]);

        // Opciones del gráfico
        var options = {
          title: 'Conversaciones Atendidas',
          curveType: 'function',
          // Línea suave
          legend: {
            position: 'bottom'
          },
          hAxis: {
            title: 'Fecha',
            format: 'dd MMM' // Formato del eje horizontal
          },
          vAxis: {
            title: 'Número de Conversaciones'
          },
          height: 500
        };

        // Dibujar el gráfico
        chart.draw(data, options);
      });
    }
  }
};